export { default } from './OmiseCard'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseCard/index.js